import styles from './Misc.module.css';

/*  Badge  */
export const Badge = ({ label, status }) => (
  <span className={`${styles.badge} badge-${status || label?.toLowerCase()}`}>
    {label}
  </span>
);

/*  Spinner  */
export const Spinner = ({ size = 32 }) => (
  <div className={styles.spinnerWrap}>
    <div className={styles.spinner} style={{ width: size, height: size }} />
  </div>
);

/*  Modal  */
export const Modal = ({ title, children, onClose }) => (
  <div className={styles.overlay} onClick={e => e.target === e.currentTarget && onClose()}>
    <div className={styles.modal}>
      <div className={styles.modalHeader}>
        <h3 className={styles.modalTitle}>{title}</h3>
        <button className={styles.closeBtn} onClick={onClose}>✕</button>
      </div>
      <div className={styles.modalBody}>{children}</div>
    </div>
  </div>
);

/*  EmptyState  */
export const EmptyState = ({ icon = '📭', title, subtitle }) => (
  <div className={styles.empty}>
    <span className={styles.emptyIcon}>{icon}</span>
    <p className={styles.emptyTitle}>{title}</p>
    {subtitle && <p className={styles.emptySub}>{subtitle}</p>}
  </div>
);

/*  Pagination  */
export const Pagination = ({ page, pages, onChange }) => {
  if (pages <= 1) return null;
  return (
    <div className={styles.pagination}>
      <button onClick={() => onChange(page - 1)} disabled={page === 1}>‹ Prev</button>
      <span>{page} / {pages}</span>
      <button onClick={() => onChange(page + 1)} disabled={page === pages}>Next ›</button>
    </div>
  );
};
